import _ from 'lodash'
var jQuery = require('jquery')

var _state = null
var _commit = null

let getMetricsForCommunities = _.debounce(() => {
  let state = _state
  let commit = _commit

  let pendingCommunities = state.pendingCommunities
  commit('clearCommunityQueue')

  pendingCommunities = pendingCommunities.map(function (community) { return community.name })

  jQuery.getJSON('/community_metrics/', {'communities': JSON.stringify(pendingCommunities)}, function (communityMetrics) {
    var metrics = {}
    for (let i = 0; i < communityMetrics.length; i++) {
      let cm = communityMetrics[i]
      if (!(communityMetrics[i].community__name in metrics)) {
        metrics[cm.community__name] = {'FCM': {}, 'TCM': {}, 'HCM': {}}
      }

      metrics[cm.community__name][cm.metric__metric_category__name][cm.metric__name] = {
        'dataset_link': cm.dataset_link,
        'score': cm.score,
        'data_availability_range': cm.data_availability_range
      }
    }
    commit({
      type: 'saveCommunityMetrics',
      metrics: metrics
    })
  })
}, 750)

export const getMetricsForCommunity = ({commit, state}, community) => {
  if (!(community.name in state.communityMetrics)) {
    commit({
      type: 'queueCommunity',
      community: community
    })
    _commit = commit
    _state = state

    getMetricsForCommunities()
  }
}

export const getMetricsForCensusArea = ({commit, state}, censusAreaID) => {
  let communities = state.communityList.filter(community => {
    return community.census_area === censusAreaID
  })
  for (let i = 0; i < communities.length; i++) {
    getMetricsForCommunity({commit, state}, communities[i])
  }
}

export const getMetricsForAEAEnergyRegion = ({commit, state}, aeaEnergyRegionID) => {
  let communities = state.communityList.filter(community => {
    return community.aea_energy_region === aeaEnergyRegionID
  })
  for (let i = 0; i < communities.length; i++) {
    getMetricsForCommunity({commit, state}, communities[i])
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js